import { api } from '@/fsd/shared/api';

export const getPhotoRequest = async () => {
  const data = await api.get('/api/v1/account/photo');
  return data;
};
